import React from 'react'
import { ListGroup } from 'react-bootstrap'
import { getAllNotification, markReadNotificatiopn } from '../../api'
import NotificationRow from '../../../../components/NotificationModal/notificationRow'
import CustomPagination from '../../../../components/Pagination'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { useAppDispatch } from '../../../../redux/hook'

const NotificationTable = ({
    type,
    activeTab,
}: {
    type: string
    activeTab: string
}) => {
    const [currentPage, setCurrentPage] = React.useState<number>(1)
    const [totalCount, setTotalCount] = React.useState<number>(1)
    const [notifications, setNotifications] = React.useState<any[]>([])
    const totalPages = Math.ceil(totalCount / 10)
    const dispatch = useAppDispatch()

    const loadData = async () => {
        dispatch(SHOW_LOADER())
        try {
            let res
            if (activeTab === type) {
                res = await getAllNotification({
                    currentPage: currentPage,
                    recordsPerPage: 10,
                    unReadNotifications: type === 'all' ? false : true,
                })
            }
            res?.data?.data?.sort(
                (a: { createdOn: string }, b: { createdOn: string }) =>
                    new Date(b.createdOn).getTime() -
                    new Date(a.createdOn).getTime()
            )
            setNotifications(res?.data?.data)
            setTotalCount(res?.data?.totalCount)
            dispatch(HIDE_LOADER())
        } catch (e) {
            console.error('Error', e)
            dispatch(HIDE_LOADER())
        }
    }
    React.useEffect(() => {
        loadData()
    }, [activeTab, currentPage])

    const getCurrentPage = (page: number) => {
        setCurrentPage(page)
    }

    const readNotification = async (id: string | null) => {
        try {
            const payload = {
                notificationId: id,
                isAllMarkAsRead: id ? false : true,
            }
            const res = await markReadNotificatiopn(payload)
            if (res) {
                return setNotifications((prev) =>
                    prev.map((item) => {
                        if (item.id === id) {
                            return {
                                ...item,
                                isSeen: true,
                            }
                        }
                        return item
                    })
                )
            }
        } catch (e) {
            console.error('Error', e)
        }
    }

    return (
        <ListGroup variant="flush" className="n-list">
            {notifications?.length > 0 &&
                notifications.map((notification, index) => (
                    <NotificationRow
                        key={index}
                        {...notification}
                        readFunction={readNotification}
                    />
                ))}
            {notifications?.length > 0 && (
                <div className="mt-2">
                    <CustomPagination
                        totalPages={totalPages}
                        currentPage={currentPage}
                        getPageNumber={getCurrentPage}
                    />
                </div>
            )}
        </ListGroup>
    )
}
export default NotificationTable
